
const config = {
  LEGACY_API_BASE_URL: 'https://binarynate.appspot.com',
  GOOGLE_MAPS_API_KEY: 'AIzaSyBomUEp-KbtQHc8Wq-xcEIx_i4QIcBI_mg',
  GOOGLE_ANALYTICS_ID: 'UA-123391965-1'
};

export default config;



// WEBPACK FOOTER //
// ./src/config.js